export default "__VITE_ASSET__DcKy1dTa__"